// Default content auto-filled into new quotations. Editable per quotation.

export const DEFAULT_INCLUSIONS = `We offer a comprehensive range of premium amenities, including fully air-conditioned workspaces, UPS and generator backup, high-speed internet, unlimited tea/green tea and coffee, a dedicated cafeteria floor, table tennis, foosball, meeting rooms, huddle rooms, CCTV surveillance, on-site security, separate prayer rooms for gents and ladies, office support staff, printing, photocopying/scanning services, and a vending machine.

Additionally, the location offers convenient access to nearby facilities including a gym, park, hospital, and mosque, all within the same vicinity.`;

export const DEFAULT_TERMS_AND_CONDITIONS = `Validity: This quotation is valid for 7 Days from the date of issue.
Revision of Rent: Rent will be revised after 1 year
Payment Terms: Payment for the co-working space package is to be made in advance on a monthly basis.
Taxes: Any applicable taxes or levies will be additional and will be borne by the customer.`;

export const DEFAULT_NOTES = ``;

export const COMPANY_INFO = {
    name: 'WorkBench-New',
    addressLines: [
        '13-D Commercial Valancia Town Lahore.',
        'Lahore Punjab 54000',
        'Pakistan'
    ]
};
